module.exports = __webpack_public_path__ + "static/media/3C.bbee349b.svg";